import React from "react";
import {
    DeleteTwoTone,
    EditTwoTone,
    ProfileTwoTone,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import HTTP from "../../services/httpService";
import { notification, Popconfirm } from "antd";
import { getUserRole } from "../../services/util";

const column = ({
    openAlarmModal,
    getAlarms,
    hotelListRes: hotels,
    alarmPriority,
    alarmType,
    showHistory,
}) => {
    const getPriority = (priority) => {
        const name = alarmPriority.find((e) => e.value == priority)?.name ?? "";
        return <span>{name}</span>;
    };

    const getAlarmType = (type) => {
        let name = "";
        const matched = alarmType.find((e) => e.key == type);
        if (matched) {
            name = matched.title;
        }
        return name;
    };

    const deleteAlarms = async (id, staff_id) => {
        const userRoleId = localStorage.getItem("userRoleId");
        if (
            getUserRole(userRoleId) !== "Super Admin" &&
            getUserRole(userRoleId) !== "Admin"
        ) {
            return notification["error"]({
                message: "You are not allowed to perform this action.",
            });
        }
        const formData = { id, staff_id };
        const { success, message } = await HTTP(
            "/alarms/deleteAlarm",
            formData,
        );

        if (success === 0) {
            return notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: message,
            });
        }
        getAlarms();
    };

    return [
        {
            title: "Alarm Name",
            dataIndex: "alarm_name",
            key: "alarm_name",
            sorter: (a, b) => a.alarm_name.length - b.alarm_name.length,
            width: "10%",
        },
        {
            title: "Hotel Names",
            dataIndex: "alarm_hotel_ids",
            key: "alarm_hotel_ids",
            render: (record) =>
                record &&
                record.map((item) => {
                    const hotel_details = hotels?.data?.find(
                        (e) => e.hotel_id == item,
                    );
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{hotel_details?.hotel_name}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
            width: "18%",
        },
        {
            title: "Emails",
            dataIndex: "alarm_email_ids",
            key: "alarm_email_ids",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{item}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
            width: "20%",
        },
        {
            title: "Phone Numbers",
            dataIndex: "alarm_phone_numbers",
            key: "alarm_phone_numbers",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{item}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
            width: "20%",
        },
        {
            title: "Priority",
            dataIndex: "priority",
            key: "priority",
            render: (record) => getPriority(record),
            sorter: (a, b) => a.priority - b.priority,
            width: "7%",
        },
        {
            title: "Alarm type",
            dataIndex: "alarm_type",
            key: "alarm_type",
            render: (record) =>
                record &&
                record.map((item) => {
                    return (
                        <React.Fragment key={String(Math.random())}>
                            <span>{getAlarmType(item)}</span>
                            <br />
                        </React.Fragment>
                    );
                }),
            width: "10%",
        },
        {
            title: "Created By",
            render: (text, record) => (
                <span>
                    {`${record.staff_first_name} ${record.staff_last_name}`}
                </span>
            ),
            width: "10%",
        },
        {
            title: "Action",
            width: 65,
            render: (record) => (
                <>
                    <Popconfirm
                        onConfirm={() =>
                            deleteAlarms(record.id, record.staff_id)
                        }
                        title="Are you sure want to delete?"
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    color: "red",
                                }}
                            />
                        }
                    >
                        <DeleteTwoTone
                            className="actionIcon"
                            // id={record.id}
                            disabled={false}
                            /*   onClick={() =>
                                deleteAlarms(record.id, record.staff_id)
                            } */
                        />
                    </Popconfirm>
                    <EditTwoTone
                        className="actionIcon"
                        id={record.id}
                        onClick={() => openAlarmModal(record)}
                    />
                    <ProfileTwoTone
                        className="actionIcon"
                        id={record.id}
                        onClick={showHistory}
                    />
                </>
            ),
        },
    ];
};

export default column;
